import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {GetAllProductsAction, GetNonLicensedSolutionsAction} from '../../store/actions/admin-panel.action';
import {getAllProducts, getNonLicensedSolutions} from '../../store/selectors/admin-panel.selector';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {TimeZoneService} from '@core/services/time-zone.service';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
    standalone: false,
    selector: 'lib-add-solution',
  templateUrl: './add-solution.component.html',
  styleUrls: ['./add-solution.component.scss']
})
export class AddSolutionComponent implements OnInit, OnDestroy {

  result: any;
  userName: string;
  addSolutionForm: any;
  fieldStyle = {};
  unSubscribe$ = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<AddSolutionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private formBuilder: FormBuilder,
              private timeZoneService: TimeZoneService,
              private store: Store<AdminPanelState>) {
    this.result = {
      save: false,
      solutions: []
    };
  }

  ngOnInit() {
    this.userName = this.data.userName;
    this.fieldStyle['height'] = '250px';

    this.addSolutionForm = this.formBuilder.group({
      productCode: ['', Validators.required],
      solutions: [[]],
      expiryDate: [this.addOneYear(new Date())],
      isActive: [true]
    });

    this.store.pipe(select(getAllProducts), takeUntil(this.unSubscribe$))
        .subscribe(products => this.data.products = products);

    this.store.pipe(
        select(getNonLicensedSolutions), 
        takeUntil(this.unSubscribe$)
    ).subscribe(solutions => {
        if (solutions && solutions.length > 0) {
          this.data.solutions = [...solutions].sort((a, b) => 
            a.solutionName.localeCompare(b.solutionName, undefined, { sensitivity: 'base' })
          );
        }
    });

    this.store.dispatch(new GetAllProductsAction());
    this.data.solutions = null;
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onSelectionChange() {
    this.store.dispatch(new GetNonLicensedSolutionsAction(this.userName, this.addSolutionForm.value.productCode));
    this.addSolutionForm.value.solutions = [];
    this.addSolutionForm.status = 'INVALID';
  }

  onSave() {
    if (this.addSolutionForm.valid) {
      this.result.save = true;
      this.result.solutions = this.addSolutionForm.value.solutions;
      for (const sol of this.result.solutions) {
        sol.isActive = this.addSolutionForm.value.isActive;
        sol.expiryDate = this.timeZoneService.getUTCDateWithoutTime(this.addSolutionForm.value.expiryDate);
      }
    } else {
      this.result.save = false;
    }
  }

  onClickAddOneYear() {
    this.addSolutionForm.value.expiryDate = this.addOneYear(this.addSolutionForm.value.expiryDate);
  }

  addOneYear(expiryDate) {
    const currentExpiryDate = this.timeZoneService.getUTCDateWithoutTime(expiryDate);
    return this.timeZoneService.getUTCDateWithoutTime(
      new Date(currentExpiryDate.getFullYear() + 1, currentExpiryDate.getMonth(), currentExpiryDate.getDate()));
  }

  onCheckboxChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addSolutionForm.value.solutions.push(event.source.value);
    } else {
      this.addSolutionForm.value.solutions = this.addSolutionForm.value.solutions.filter(i => i !== event.source.value);
    }

    if (this.addSolutionForm.value.solutions.length === 0) {
      this.addSolutionForm.status = 'INVALID';
    } else {
      this.addSolutionForm.status = 'VALID';
    }

    this.onSave();
  }

  onDatePickerChange(event: any) {
    this.addSolutionForm.value.expiryDate = event.value;
  }
}
